import theme from '@/styles/theme';

interface Props {
  size?: number;
  bodyColor?: string;
  edgeColor?: string;
}
const ContentFile = ({ size = 48, bodyColor = theme.color.gray100, edgeColor = theme.color.gray300 }: Props) => {
  return (
    <svg width={size} height={size} viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3040_59478)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.57157 0C7.20761 0 5.89948 0.541834 4.93502 1.50631C3.97056 2.47078 3.42871 3.7789 3.42871 5.14286V42.8571C3.42871 44.221 3.97056 45.5294 4.93502 46.4938C5.89948 47.4583 7.20758 48 8.57157 48H39.4287C40.7926 48 42.1009 47.4583 43.0654 46.4938C44.0299 45.5294 44.5716 44.221 44.5716 42.8571V18.8571C44.5716 18.4025 44.3909 17.9664 44.0696 17.645L26.9266 0.502104C26.6051 0.180612 26.1691 0 25.7144 0H8.57157Z'
          fill={bodyColor}
        />
        <path
          d='M44.5715 18.8571C44.5715 18.4025 44.3908 17.9664 44.0696 17.645L26.9265 0.502104C26.6051 0.180612 26.169 0 25.7144 0V17.1429C25.7144 18.0896 26.4819 18.8571 27.4286 18.8571H44.5715Z'
          fill={edgeColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_3040_59478'>
          <rect width='48' height='48' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ContentFile;
